import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import css from './ServiceProviderFilter.module.css';

const ServiceProviderFilter = ({ id, label, categories }) => {
  const history = useHistory();
  const location = useLocation();

  // Parse existing URL params for categories
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const mainSelected = useMemo(() => {
    const v = params.get('pub_categoryLevel1');
    return v ? v.split(',') : [];
  }, [params]);
  const subSelected = useMemo(() => {
    const v = params.get('pub_categoryLevel2');
    return v ? v.split(',') : [];
  }, [params]);

  const isChecked = (itemId) => {
    return mainSelected.includes(itemId) || subSelected.includes(itemId);
  };

  const handleCheckboxChange = (itemId, level) => {
    const newParams = new URLSearchParams(params.toString());
    const key = level === 1 ? 'pub_categoryLevel1' : 'pub_categoryLevel2';
    const existing = newParams.get(key);
    const values = existing ? existing.split(',') : [];
    const updated = values.includes(itemId)
      ? values.filter(v => v !== itemId)
      : [...values, itemId];

    if (updated.length) {
      newParams.set(key, updated.join(','));
    } else {
      newParams.delete(key);
    }

    // Push merged URL params
    history.push({ pathname: location.pathname, search: newParams.toString() });
  };

  return (
    <div id={id} className={css.wrapper}>
      <label className={css.label}>{label}</label>
      <div className={css.categoryList}>
        {categories.map(category => (
          <div key={category.id} className={css.categoryBlock}>
            <label>
              <input
                type="checkbox"
                checked={mainSelected.includes(category.id)}
                onChange={() => handleCheckboxChange(category.id, 1)}
              />
              {category.name}
            </label>

            {/* Show subcategories only when main category is selected */}
            {mainSelected.includes(category.id) && category.subcategories.length > 0 && (
              <div className={css.subcategories}>
                {category.subcategories.map(sub => (
                  <label key={sub.id} className={css.subcategoryItem}>
                    <input
                      type="checkbox"
                      checked={subSelected.includes(sub.id)}
                      onChange={() => handleCheckboxChange(sub.id, 2)}
                    />
                    {sub.name}
                  </label>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceProviderFilter;
